import { AuthZeroProvider } from './providers/AuthZeroProvider';
import { DummyProvider } from './providers/DummyProvider';

export class AuthProviderFactory {
    constructor() { }

    build(authConfig) {
        if(authConfig) {
            return new AuthZeroProvider(authConfig.AUTH0);
        }
        else {
            return new DummyProvider();
        }
    }
}

const authFactory = new AuthProviderFactory();
export default authFactory;